import config from '../configs';
import { sendErrorNotice } from "@/commons/utils";

function login (cb, $http, loginInfo) {
  var req = {
      'user_name': loginInfo.user_name,
      'password': loginInfo.password
  }
  var endpoint = config.API; 
  $http.post(`${endpoint}/api-token-auth/`,req).then(function(res){ 
      setTimeout(() => cb(res.data), 100);
  },
  function (err) {
    sendErrorNotice("Tài khoản hoặc mật khẩu không đúng.");
  });        
}

function logout (cb, $http, loginInfo, token) {
  var req = {}
  var header = {
    "Authorization": `Bearer ${token}`,
    "Content-Type": "application/json",
    "accept": "application/json",
  };
  var endpoint = config.API; 
  $http.post(`${endpoint}/admin/api/logout/`,req, {headers: header}).then(function(res){ 
      setTimeout(() => cb(res.data), 100);
  },function(res){ 
    setTimeout(() => cb({'status': 'error', 'message': res}), 100);
  });        
}

function getAllUsers(cb, $http, token){
  const req = {
    headers: {
      "Authorization": `Bearer ${token}`,
      "Content-Type": "application/json",
      "accept": "application/json",
    }
  };
  var endpoint = config.API; 
  $http.get(`${endpoint}/admin/api/users/`,req).then(function(res){ 
      setTimeout(() => cb(res.data), 100);
  },function(res){ 
    setTimeout(() => cb({'status': 'error', 'message': res}), 100);
  });
}

export default{
  login,
  logout,
  getAllUsers
}